import Constants from '../../../app/utils/constants'
import colors from '../../theme/color'
import { motion, type Variants } from 'framer-motion'

const { portfolioStatsItems } = Constants

// ✅ Parent stagger animation
const containerVariants: Variants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.25,
    },
  },
}

// ✅ Individual item animation
const itemVariants: Variants = {
  hidden: {
    scale: 0.5,
    opacity: 0,
    y: 40,
  },
  show: {
    scale: 1,
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut',
    },
  },
}

const ProtfolioStat = () => {
  return (
    <section
      className="pt-16 md:py-20 md:px-5"
      style={{ backgroundColor: colors.panelDarkAlt }}
    >
      <motion.div
        className="grid grid-cols-2 gap-8 md:grid-cols-3 xl:mx-[10%]"
        variants={containerVariants}
        initial="hidden"
        whileInView="show"
        viewport={{ once: false, amount: 0.3 }}
      >
        {portfolioStatsItems.map((item, index) => {
          const isDown = index === 1
          const gradientAngle = isDown ? '0deg' : '180deg'

          return (
            <motion.div
              key={item.num}
              variants={itemVariants}
              className="flex justify-center"
            >
              <div
                className={`p-[2px] rounded-full ${
                  isDown
                    ? 'bg-linear-to-t from-[#745EF0] via-[#745EF033] to-transparent'
                    : 'bg-linear-to-b from-[#745EF0] via-[#745EF033] to-transparent'
                }`}
              >
                {/* Inner Circle */}
                <div
                  className="
                    group cursor-pointer
                    flex items-center justify-center
                    rounded-full
                    h-[160px] w-[160px]
                    min-[400px]:h-[180px] min-[400px]:w-[180px]
                    sm:h-[200px] sm:w-[200px]
                    md:h-[230px] md:w-[230px]
                    lg:h-[250px] lg:w-[250px]
                    xl:h-[270px] xl:w-[270px]
                    2xl:h-[350px] 2xl:w-[350px]
                  "
                  style={{
                    backgroundImage: `linear-gradient(${gradientAngle}, ${colors.portfolioStatsFillStart} 20%, #745EF033 90%, ${colors.industryB} 100%)`,
                  }}
                >
                  <div className="relative flex h-full w-full flex-col items-center justify-center overflow-hidden rounded-full text-center sm:px-4 sm:py-4 md:px-5 md:py-5">

                    {/* Overlay */}
                    <div className="absolute inset-0 bg-black/30 backdrop-blur-sm transition-opacity duration-300 group-hover:opacity-0" />

                    {/* Hover Gradient */}
                    <div
                      className={`
                        absolute inset-0 scale-y-0 rounded-full
                        transition-transform duration-700 ease-in 
                        group-hover:scale-y-100
                        ${isDown ? 'origin-bottom' : 'origin-top'}
                      `}
                      style={{
                        backgroundImage: `linear-gradient(${gradientAngle}, ${colors.purpleAlt} 0%, ${colors.portfolioStatsHoverEnd} 100%)`,
                      }}
                    />

                    {/* Content */}
                    <div className="relative z-10 flex flex-col items-center px-3 py-3">

                      {/* ✅ FIXED NUMBER HOVER */}
                      <p
                        className="
                          font-gilroy-bold 
                          text-2xl 
                          sm:text-3xl md:text-4xl lg:text-4xl xl:text-5xl
                          transition-colors duration-300
                          text-[#745EF0]
                          group-hover:text-[#0E0924]
                        "
                      >
                        {item.num}.
                      </p>

                      <p className="mt-1 text-xl font-rajdhani font-semibold text-white sm:mt-2 sm:text-sm md:text-3xl lg:text-4xl xl:text-5xl">
                        {item.title}
                      </p>

                      <div className="mt-2 space-y-0.5 sm:mt-3 sm:space-y-1">
                        {item.points.map((point, i) => (
                          <h6
                            key={i}
                            className="text-[15px] font-gilroy-medium text-white/80 sm:text-sm md:text-base lg:text-lg xl:text-2xl 2xl:text-3xl"
                          >
                            {point}
                          </h6>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          )
        })}
      </motion.div>
    </section>
  )
}

export default ProtfolioStat